import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // Auth
      login: 'تسجيل الدخول',
      register: 'تسجيل جديد',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      fullName: 'الاسم الكامل',
      modernHrSolution: 'حل متكامل وذكي لإدارة الموارد البشرية',
      fullNameAr: 'الاسم الكامل (بالعربية)',
      phone: 'رقم الهاتف',
      loginWithGoogle: 'تسجيل الدخول عبر Google',
      loginWithFace: 'تسجيل الدخول بالوجه',
      faceLoginTitle: 'تسجيل الدخول ببصمة الوجه',
      faceLoginDescription: 'ضع وجهك أمام الكاميرا للتعرف عليك',
      faceLoginSuccess: 'تم تسجيل الدخول بنجاح',
      faceLoginFailed: 'لم يتم التعرف على الوجه',
      noFaceRegistered: 'لا يوجد مستخدمين مسجلين ببصمة الوجه',
      faceLoginConfidence: 'نسبة التطابق',
      loginWithBiometric: 'تسجيل الدخول بالبصمة',
      setupBiometric: 'إعداد Face ID / Touch ID',
      setupBiometricTitle: 'إعداد البصمة',
      setupBiometricDescription: 'قم بتسجيل بصمة جهازك (Face ID أو Touch ID) لتسجيل الدخول بسرعة',
      setupBiometricButton: 'تسجيل البصمة',
      setupBiometricNote: 'يجب أن يكون لديك حساب نشط لإعداد البصمة',
      biometricLoginSuccess: 'تم تسجيل الدخول بنجاح',
      biometricLoginFailed: 'فشل تسجيل الدخول بالبصمة',
      biometricSetupSuccess: 'تم تسجيل البصمة بنجاح! يمكنك الآن استخدامها لتسجيل الدخول',
      biometricSetupFailed: 'فشل تسجيل البصمة',
      biometricCancelled: 'تم إلغاء العملية',
      biometricNotSupported: 'جهازك لا يدعم البصمة',
      noBiometricRegistered: 'لم تقم بتسجيل البصمة بعد. اضغط على "إعداد Face ID / Touch ID" أولاً',
      or: 'أو',
      alreadyHaveAccount: 'لديك حساب؟',
      dontHaveAccount: 'ليس لديك حساب؟',
      accountPending: 'الحساب قيد الموافقة',
      accountPendingMessage: 'حسابك في انتظار موافقة المسؤول. سيتم إخطارك عند الموافقة.',
      logout: 'تسجيل الخروج',
      newPassword: 'كلمة المرور الجديدة',
      currentPassword: 'كلمة المرور الحالية',
      passwordMismatch: 'كلمة المرور غير متطابقة',
      passwordChanged: 'تم تغيير كلمة المرور بنجاح',
      passwordMinLength: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
      
      // Registration Steps
      basicInfo: 'البيانات الأساسية',
      biometricVerification: 'التحقق البيومتري',
      nextStep: 'التالي ← التحقق البيومتري',
      previousStep: '← السابق',
      completeRegistration: '✅ إكمال التسجيل',
      registering: 'جاري التسجيل...',
      fillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
      faceCaptureRequired: 'يجب التقاط صورة الوجه للتسجيل',
      faceCaptureSuccess: 'تم التقاط صورة الوجه بنجاح',
      faceCaptureTitle: 'التقاط صورة الوجه',
      faceCaptureDescription: 'لأغراض الأمان والتحقق من الهوية عند تسجيل الحضور، يرجى التقاط صورة واضحة لوجهك.',
      retakePhoto: 'إعادة التقاط الصورة',
      capturePhoto: 'التقاط صورة الوجه',
      faceImageRequired: 'التقاط صورة الوجه مطلوب لإكمال التسجيل',
      
      // Navigation
      dashboard: 'لوحة التحكم',
      employees: 'الموظفون',
      departments: 'الأقسام',
      branches: 'فروع الشركة',
      positions: 'الوظائف',
      attendance: 'الحضور',
      leaves: 'الإجازات',
      mySalary: 'راتبي',
      salaries: 'الرواتب',
      reports: 'التقارير',
      notifications: 'الإشعارات',
      profile: 'الملف الشخصي',
      settings: 'الإعدادات',
      branch: 'الفرع',
      
      // App Settings
      appSettings: 'إعدادات التطبيق',
      updateApp: 'تحديث التطبيق',
      updateAppDescription: 'تحقق من وجود تحديثات جديدة وقم بتحميل أحدث إصدار',
      updateNow: 'تحديث الآن',
      updatingApp: 'جاري تحديث التطبيق...',
      clearCache: 'مسح الذاكرة المؤقتة',
      clearCacheDescription: 'مسح البيانات المخزنة مؤقتاً لحل مشاكل العرض',
      cacheCleared: 'تم مسح الذاكرة المؤقتة بنجاح',
      appVersion: 'إصدار التطبيق',
      
      // Dashboard
      welcome: 'مرحباً',
      totalEmployees: 'إجمالي الموظفين',
      totalDepartments: 'إجمالي الأقسام',
      activeEmployees: 'الموظفون النشطون',
      pendingApprovals: 'الموافقات المعلقة',
      todayAttendance: 'حضور اليوم',
      pendingLeaves: 'الإجازات المعلقة',
      recentActivity: 'النشاط الأخير',
      
      // Employees
      addEmployee: 'إضافة موظف',
      employeeList: 'قائمة الموظفين',
      viewEmployee: 'عرض الموظف',
      editEmployee: 'تعديل الموظف',
      deleteEmployee: 'حذف الموظف',
      approveEmployee: 'قبول الموظف',
      rejectEmployee: 'رفض الموظف',
      status: 'الحالة',
      role: 'الدور',
      department: 'القسم',
      position: 'الوظيفة',
      hireDate: 'تاريخ التوظيف',
      salary: 'الراتب',
      manager: 'المدير',
      actions: 'الإجراءات',
      
      // Attendance
      checkIn: 'تسجيل الحضور',
      checkOut: 'تسجيل الانصراف',
      date: 'التاريخ',
      checkInTime: 'وقت الحضور',
      checkOutTime: 'وقت الانصراف',
      attendanceStatus: 'الحالة',
      notes: 'ملاحظات',
      present: 'حاضر',
      absent: 'غائب',
      late: 'متأخر',
      halfDay: 'نصف يوم',
      
      // Leaves
      requestLeave: 'طلب إجازة',
      leaveType: 'نوع الإجازة',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      leaveStartDate: 'تاريخ بداية الإجازة',
      leaveEndDate: 'تاريخ نهاية الإجازة',
      reason: 'السبب',
      emergencyLeaveMonthLimit: 'لا يمكن أخذ أكثر من يومين إجازة طارئة في الشهر الواحد',
      emergencyLeaveBalanceExceeded: 'رصيد الإجازة الطارئة غير كافي',
      sickLeaveInfo: 'الإجازة المرضية غير مدفوعة. الرصيد 5 أيام سنوياً. يتطلب تقرير طبي مع QR لأكثر من 5 أيام.',
      medicalReport: 'التقرير الطبي',
      medicalReportRequired: 'يجب إرفاق تقرير طبي يتضمن رمز QR للإجازات المرضية التي تتجاوز 5 أيام',
      uploadMedicalReport: 'انقر لرفع التقرير الطبي',
      medicalReportWithQR: 'يجب أن يحتوي التقرير على رمز QR للتحقق',
      fileUploaded: 'تم رفع الملف',
      clickToChange: 'انقر للتغيير',
      fileTooLarge: 'حجم الملف كبير جداً (الحد الأقصى 5 ميجابايت)',
      viewMedicalReport: 'عرض التقرير الطبي',
      download: 'تحميل',
      close: 'إغلاق',
      unsupportedFileFormat: 'صيغة الملف غير مدعومة',
      leaveDateConflict: 'تداخل في التواريخ! لديك إجازة أخرى في هذه الفترة',
      filterReports: 'فلترة التقارير',
      allBranches: 'جميع الفروع',
      allDepartments: 'جميع الأقسام',
      allEmployees: 'جميع الموظفين',
      absentReport: 'تقرير الغياب',
      absent: 'غائب',
      noAbsentEmployees: 'لا يوجد موظفين غائبين',
      selectDailyFilter: 'يرجى اختيار فلتر يومي لعرض تقرير الغياب',
      absentReportNote: 'تقرير الغياب متاح فقط للتقارير اليومية. يرجى اختيار فلتر "اليوم" أو تاريخ محدد واحد.',
      showingResults: 'عرض النتائج',
      attendanceRecords: 'سجل حضور',
      leaveRequests: 'طلب إجازة',
      employeeName: 'اسم الموظف',
      attendanceReport: 'تقرير الحضور',
      leavesReport: 'تقرير الإجازات',
      noData: 'لا توجد بيانات',
      days: 'الأيام',
      approve: 'قبول',
      reject: 'رفض',
      pending: 'معلق',
      approved: 'مقبول',
      rejected: 'مرفوض',
      annual: 'إجازة سنوية',
      sick: 'إجازة مرضية',
      emergency: 'إجازة طارئة',
      unpaid: 'إجازة بدون راتب',
      
      // Common
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      view: 'عرض',
      search: 'بحث',
      filter: 'تصفية',
      export: 'تصدير',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات',
      success: 'نجح',
      error: 'خطأ',
      warning: 'تحذير',
      pleaseSelectDates: 'يرجى تحديد تاريخ البداية والنهاية',
      endDateBeforeStartDate: 'تاريخ النهاية يجب أن يكون بعد تاريخ البداية',
      startDateInPast: 'لا يمكن اختيار تاريخ في الماضي',
      info: 'معلومة',
      all: 'الكل',
      addDepartment: 'إضافة قسم',
      create: 'إنشاء',
      nameEnglish: 'الاسم (إنجليزي)',
      nameArabic: 'الاسم (عربي)',
      description: 'الوصف',
      
      // Roles
      admin: 'مدير',
      managerRole: 'مشرف',
      employee: 'موظف',
      manager: 'مدير',
      
      // Salaries
      addSalary: 'إضافة راتب',
      basicSalary: 'الراتب الأساسي',
      allowances: 'البدلات',
      deductions: 'الخصومات',
      total: 'الإجمالي',
      paid: 'مدفوع',
      markPaid: 'تم الدفع',
      select: 'اختر',
      month: 'الشهر',
      year: 'السنة',
      
      // Status
      active: 'نشط',
      inactive: 'غير نشط',
      suspended: 'موقوف',
      
      // Additional
      today: 'اليوم',
      hours: 'ساعة',
      totalHours: 'إجمالي الساعات',
      attendanceHistory: 'سجل الحضور',
      attendanceManagement: 'إدارة الحضور',
      todayStatus: 'حالة اليوم',
      thisMonthDays: 'أيام الحضور هذا الشهر',
      lateDays: 'أيام التأخير',
      leaveDays: 'أيام الإجازة',
      avgWorkHours: 'متوسط ساعات العمل',
      locationReady: 'الموقع جاهز',
      locationStatus: 'حالة الموقع',
      refresh: 'تحديث',
      checkedInSuccess: 'تم تسجيل الحضور بنجاح',
      checkedOutSuccess: 'تم تسجيل الانصراف بنجاح',
      totalDays: 'إجمالي الأيام',
      submit: 'إرسال',
      manageLocations: 'إدارة المواقع',
      addNewLocation: 'إضافة موقع جديد',
      locationName: 'اسم الموقع',
      latitude: 'خط العرض',
      longitude: 'خط الطول',
      radius: 'نطاق السماح',
      radiusHelp: 'المسافة المسموحة من الموقع بالمتر',
      useCurrentLocation: 'استخدام موقعي الحالي',
      addLocation: 'إضافة الموقع',
      allowedLocations: 'المواقع المسموحة',
      noLocationsAdded: 'لم يتم إضافة مواقع بعد',
      close: 'إغلاق',
      meters: 'متر',
      confirmReject: 'هل أنت متأكد من رفض هذا الموظف؟',
      confirmDelete: 'هل أنت متأكد من حذف هذا الموظف؟',
      remainingDays: 'يوم متبقي',
      used: 'مستخدم',
      days: 'أيام',
      print: 'طباعة التقرير',
      hrManagementSystem: 'نظام إدارة الموارد البشرية',
      enterEmail: 'أدخل البريد الإلكتروني',
      enterPassword: 'أدخل كلمة المرور',
      allRightsReserved: 'جميع الحقوق محفوظة',
      comprehensiveReport: 'التقرير الشامل',
      generatedOn: 'تم الإنشاء في',
      totalEmployees: 'إجمالي الموظفين',
      activeEmployees: 'الموظفون النشطون',
      todayAttendance: 'حضور اليوم',
      pendingLeaves: 'الإجازات المعلقة',
      employeesReport: 'تقرير الموظفين',
      recentAttendance: 'الحضور الأخير',
      recentLeaves: 'الإجازات الأخيرة',
      type: 'النوع',
      currency: 'العملة',
      usd: 'دولار أمريكي (USD)',
      iqd: 'دينار عراقي (IQD)',
      aed: 'درهم إماراتي (AED)',
      forgotPassword: 'نسيت كلمة المرور؟',
      sendCodeVia: 'إرسال الكود عبر',
      sendCode: 'إرسال الكود',
      verificationCode: 'كود التحقق',
      enterCode: 'أدخل الكود',
      confirmReset: 'تأكيد التغيير',
      backToLogin: 'العودة لتسجيل الدخول',
      confirmPassword: 'تأكيد كلمة المرور',
      codeNotValid: 'الكود غير صحيح أو منتهي الصلاحية',
      codeSentEmail: 'تم إرسال الكود إلى بريدك الإلكتروني',
      codeSentPhone: 'تم إرسال الكود إلى رقم هاتفك',
      sendingCode: 'جاري الإرسال...',
      confirmingReset: 'جاري التأكيد...',
      sendCodeFailed: 'فشل في إرسال الكود',
      weWillSendCode: 'سنرسل لك كود للتحقق',
      enterSentCode: 'أدخل الكود المرسل إليك',
      enterNewPassword: 'أدخل كلمة مرور جديدة',
      
      // Notifications
      notifications: 'الإشعارات',
      unreadNotifications: 'إشعارات غير مقروءة',
      markAllRead: 'تحديد الكل كمقروء',
      noNotifications: 'لا توجد إشعارات',
      allNotifications: 'الكل',
      unread: 'غير مقروء',
      read: 'مقروء',
      new: 'جديد',
      justNow: 'الآن',
      minutesAgo: 'منذ {count} دقيقة',
      hoursAgo: 'منذ {count} ساعة',
      daysAgo: 'منذ {count} يوم',
      failedFetchNotifications: 'فشل في جلب الإشعارات',
      allMarkedRead: 'تم تحديد جميع الإشعارات كمقروءة',
      failedUpdateNotifications: 'فشل في تحديث الإشعارات',
      viewAllNotifications: 'عرض جميع الإشعارات',
      
      // Settings
      settings: 'الإعدادات',
      accountInfo: 'معلومات الحساب',
      changePassword: 'تغيير كلمة المرور',
      confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
      passwordMatched: 'كلمة المرور متطابقة',
      changingPassword: 'جاري التغيير...',
      notSpecified: 'غير محدد',
      systemAdmin: 'مسؤول النظام',
      
      // Employees Modal
      editEmployee: 'تعديل موظف',
      addNewEmployee: 'إضافة موظف جديد',
      fullNameEn: 'الاسم الكامل (إنجليزي)',
      fullNameArLabel: 'الاسم الكامل (عربي)',
      qualification: 'المؤهل العلمي',
      qualificationPlaceholder: 'بكالوريوس، ماجستير، دكتوراه...',
      jobTitle: 'المنصب/الوظيفة',
      jobTitlePlaceholder: 'مدير، موظف، محاسب...',
      roleLabel: 'الدور',
      employeeRole: 'موظف',
      managerRoleLabel: 'مدير',
      adminRole: 'مسؤول',
      workBranch: 'فرع العمل',
      selectBranch: '-- اختر الفرع --',
      selectDepartment: '-- اختر القسم --',
      basicSalaryLabel: 'الراتب الأساسي',
      currencyLabel: 'العملة',
      usdCurrency: 'دولار أمريكي (USD)',
      iqdCurrency: 'دينار عراقي (IQD)',
      aedCurrency: 'درهم إماراتي (AED)',
      personalData: 'البيانات الشخصية (إجبارية)',
      nationalId: 'رقم الهوية',
      nationalIdPlaceholder: 'رقم الهوية الوطنية',
      residenceCard: 'رقم بطاقة السكن',
      residenceCardPlaceholder: 'رقم بطاقة السكن',
      nationality: 'الجنسية',
      emiratesId: 'الهوية الإماراتية',
      unifiedCardNumber: 'البطاقة الموحدة',
      addressEmirate: 'الإمارة',
      addressCity: 'المدينة',
      addressGovernorate: 'المحافظة',
      addressDistrict: 'القضاء',
      maritalStatus: 'الحالة الاجتماعية',
      selectOption: '-- اختر --',
      single: 'أعزب',
      married: 'متزوج',
      divorced: 'مطلق',
      widowed: 'أرمل',
      gender: 'الجنس',
      male: 'ذكر',
      female: 'أنثى',
      graduationYear: 'سنة التخرج',
      birthDate: 'تاريخ الميلاد',
      passportNumber: 'رقم جواز السفر',
      passportNumberPlaceholder: 'رقم جواز السفر',
      addressLabel: 'العنوان',
      addressPlaceholder: 'العنوان الكامل',
      startDate: 'تاريخ المباشرة بالعمل',
      completeFieldsFirst: 'يجب إكمال جميع الحقول الإجبارية قبل تحديد تاريخ المباشرة',
      allowances: 'البدلات',
      allowanceType: 'نوع البدل',
      amount: 'المبلغ',
      completeRequiredFieldsFirst: 'يجب إكمال جميع الحقول الإجبارية قبل تحديد تاريخ المباشرة',
      installApp: 'تثبيت التطبيق',
      appInstalled: 'تم تثبيت التطبيق بنجاح!',
      basicInfo: 'البيانات الأساسية',
      biometricVerification: 'التحقق البيومتري',
      deductionsLabel: 'الخصومات',
      deductionType: 'نوع الخصم',
      saveEmployee: 'حفظ',
      cancelAction: 'إلغاء',
      employeeUpdated: 'تم تحديث الموظف بنجاح',
      employeeAdded: 'تم إضافة الموظف بنجاح',
      saveEmployeeFailed: 'فشل في حفظ الموظف',
      locationSet: 'تم تحديد الموقع الحالي',
      locationFailed: 'فشل في الحصول على الموقع',
      browserNoLocation: 'المتصفح لا يدعم تحديد الموقع',
      fillAllFieldsLocation: 'يرجى ملء جميع الحقول',
      locationAdded: 'تم إضافة الموقع بنجاح',
      addLocationFailed: 'فشل في إضافة الموقع',
      locationDeleted: 'تم حذف الموقع',
      deleteLocationFailed: 'فشل في حذف الموقع',
      locating: 'جاري التحديد...',
      
      // MySalary
      mySalaryTitle: 'راتبي',
      accumulatedSalary: 'الراتب المتراكم حتى الآن',
      attendanceDays: 'أيام الحضور',
      paidFridays: 'عطلة نهاية الأسبوع',
      leaveDays: 'أيام الإجازة',
      dailyRate: 'سعر اليوم',
      totalPaidDays: 'إجمالي الأيام المدفوعة',
      remainingDaysLabel: 'المتبقي',
      day: 'يوم',
      fridayPaidNote: 'الجمعة تُحسب تلقائياً بدون بصمة',
      leaveNoPay: 'أيام الإجازة بدون راتب',
      monthlySalaryDetails: 'تفاصيل الراتب الشهري',
      plusAllowances: '+ البدلات',
      minusDeductions: '- الخصومات',
      monthlyTotal: 'الإجمالي الشهري',
      dailyMotivation: 'التحفيز اليومي',
      workDayAdds: 'كل يوم عمل يضيف لراتبك',
      daysToFullSalary: 'يوم للوصول للراتب الكامل',
      congratsMonthComplete: 'مبروك! أكملت الشهر بنجاح',
      totalAllowances: 'إجمالي البدلات',
      totalDeductions: 'إجمالي الخصومات',
      earnedSoFar: 'المكتسب حتى الآن',
      salaryNotSet: 'لم يتم تحديد راتبك بعد',
      fetchSalaryFailed: 'فشل في جلب معلومات الراتب',
      
      // Branches
      companyBranches: 'فروع الشركة',
      addBranch: 'إضافة فرع',
      noBranches: 'لا توجد فروع. أضف فرعاً جديداً.',
      editBranch: 'تعديل فرع',
      addNewBranch: 'إضافة فرع جديد',
      branchNameAr: 'اسم الفرع (عربي)',
      branchNameEn: 'اسم الفرع (إنجليزي)',
      branchAddress: 'العنوان',
      branchAddressPlaceholder: 'مثال: بغداد - الكرادة - شارع أبو نواس',
      geoLocation: 'الموقع الجغرافي',
      detectMyLocation: 'تحديد موقعي الحالي',
      detectingLocation: 'جاري التحديد...',
      mapClickHint: 'انقر على الخريطة لتحديد موقع الفرع، أو استخدم زر "تحديد موقعي الحالي"',
      latitudeLabel: 'خط العرض',
      longitudeLabel: 'خط الطول',
      allowedDistance: 'المسافة المسموحة (متر)',
      workHours: 'ساعات العمل',
      workStartTime: 'وقت بدء الدوام',
      workEndTime: 'وقت نهاية الدوام',
      gracePeriod: 'فترة السماح (دقيقة)',
      branchEnabled: 'مفعّل',
      branchDisabled: 'معطّل',
      branchIsActive: 'الفرع مفعّل',
      branchUpdated: 'تم تحديث الفرع بنجاح',
      branchAdded: 'تم إضافة الفرع بنجاح',
      saveBranchFailed: 'فشل في حفظ الفرع',
      branchDeleted: 'تم حذف الفرع',
      deleteBranchFailed: 'فشل في حذف الفرع',
      confirmDeleteBranch: 'هل أنت متأكد من حذف هذا الفرع؟',
      pleaseSetLocation: 'يرجى تحديد موقع الفرع',
      locationSuccess: 'تم تحديد الموقع بنجاح',
      locationServiceError: 'فشل في تحديد الموقع. يرجى تفعيل خدمة الموقع.',
      fetchBranchesFailed: 'فشل في جلب الفروع',
      minutes: 'دقيقة',
      
      // Attendance
      workBranchInfo: 'فرع العمل',
      branchWorkHours: 'ساعات العمل',
      branchGracePeriod: 'فترة السماح',
      completeProfileWarning: 'يرجى إكمال بياناتك الشخصية لتفعيل نظام الحضور',
      missingFields: 'الحقول الناقصة',
      contactAdmin: 'تواصل مع المدير لإكمال بياناتك',
      requiredCheckoutTime: 'وقت الانصراف المطلوب',
      lateMinutes: 'دقائق التأخير',
      
      // Reports page
      lateReport: 'تقرير المتأخرين',
      dateRange: 'الفترة الزمنية',
      custom: 'مخصص',
      selectMonth: 'اختر الشهر',
      selectYear: 'اختر السنة',
      totalLateRecords: 'إجمالي سجلات التأخير',
      uniqueLateEmployees: 'موظفين متأخرين',
      totalLateMinutes: 'إجمالي دقائق التأخير',
      noLateEmployees: 'لا يوجد موظفين متأخرين',
      lateRecords: 'سجل تأخير',
      presentToday: 'الحاضرون',
      lateToday: 'المتأخرون',
      overview: 'نظرة عامة',
      noRecords: 'لا توجد سجلات',
      locatingPosition: 'جاري تحديد الموقع...',
      locationNotAvailable: 'موقعك غير متاح',
      allowLocationAccess: 'يرجى السماح بالوصول للموقع',
      locationDetected: 'تم تحديد موقعك بنجاح',
      accuracy: 'دقة',
      checkingInProgress: 'جاري التسجيل...',
      faceNotRegistered: 'لم يتم تسجيل صورة الوجه. يرجى التواصل مع المدير.',
      complete: 'مكتمل',
      inProgress: 'جاري العمل',
      
      // Attendance additional
      browserNoLocationSupport: 'المتصفح لا يدعم خدمة تحديد الموقع',
      dayNotCounted: 'لم يُحسب هذا اليوم في الراتب',
      dayCounted: 'تم احتساب هذا اليوم',
      faceVerified: 'بصمة الوجه',
      locationVerifiedLabel: 'الموقع',
      verified: 'تم التحقق',
      notVerified: 'لم يتم التحقق',
      verificationRequired: 'مطلوب التحقق من بصمة الوجه والموقع',
      uncountedDays: 'أيام غير محسوبة',
      uncountedDaysNote: 'أيام العمل بدون تحقق (بصمة/موقع)',
      completeProfileFirst: 'يرجى إكمال بياناتك الشخصية أولاً',
      missingFieldsCount: 'حقول ناقصة',
      faceImage: 'صورة الوجه البيومترية',
      address: 'العنوان',
      
      // Face Capture
      loadingFaceRecognition: 'جاري تحميل نظام التعرف على الوجه...',
      pleaseWait: 'يرجى الانتظار',
      faceModelLoadFailed: 'فشل في تحميل نموذج التعرف على الوجه',
      cameraAccessFailed: 'فشل في الوصول إلى الكاميرا. يرجى السماح بالوصول.',
      captureFaceTitle: 'التقاط صورة الوجه',
      verifyIdentity: 'التحقق من الهوية',
      faceDetected: 'تم اكتشاف الوجه',
      noFaceDetected: 'لم يتم اكتشاف وجه',
      verificationSuccess: 'تم التحقق بنجاح',
      faceMismatch: 'الوجه غير مطابق',
      captureInstruction: 'ضع وجهك في منتصف الإطار واضغط "التقاط"',
      verifyInstruction: 'انظر إلى الكاميرا للتحقق من هويتك',
      captureBtn: 'التقاط الصورة',
      confirmVerify: 'تأكيد التحقق',
      photoSuccess: 'تم التقاط الصورة بنجاح',
      savePhoto: 'حفظ الصورة',
      retakePhotoBtn: 'إعادة الالتقاط',
      close: 'إغلاق'
    }
  },
  en: {
    translation: {
      // Auth
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      modernHrSolution: 'A complete smart solution for HR management',
      fullNameAr: 'Full Name (Arabic)',
      phone: 'Phone',
      loginWithGoogle: 'Login with Google',
      loginWithFace: 'Login with Face',
      faceLoginTitle: 'Face Login',
      faceLoginDescription: 'Position your face in front of the camera to login',
      faceLoginSuccess: 'Login successful',
      faceLoginFailed: 'Face not recognized',
      noFaceRegistered: 'No users registered with face',
      faceLoginConfidence: 'Match confidence',
      loginWithBiometric: 'Login with Face ID / Touch ID',
      setupBiometric: 'Setup Face ID / Touch ID',
      setupBiometricTitle: 'Setup Biometric',
      setupBiometricDescription: 'Register your device biometric (Face ID or Touch ID) for quick login',
      setupBiometricButton: 'Register Biometric',
      setupBiometricNote: 'You must have an active account to setup biometric',
      biometricLoginSuccess: 'Login successful',
      biometricLoginFailed: 'Biometric login failed',
      biometricSetupSuccess: 'Biometric registered successfully! You can now use it to login',
      biometricSetupFailed: 'Biometric registration failed',
      biometricCancelled: 'Operation cancelled',
      biometricNotSupported: 'Your device does not support biometric authentication',
      noBiometricRegistered: 'You have not registered your biometric yet. Click "Setup Face ID / Touch ID" first',
      or: 'OR',
      alreadyHaveAccount: 'Already have an account?',
      dontHaveAccount: "Don't have an account?",
      accountPending: 'Account Pending Approval',
      accountPendingMessage: 'Your account is awaiting admin approval. You will be notified once approved.',
      logout: 'Logout',
      newPassword: 'New Password',
      currentPassword: 'Current Password',
      passwordMismatch: 'Password mismatch',
      passwordChanged: 'Password changed successfully',
      passwordMinLength: 'Password must be at least 6 characters',
      
      // Registration Steps
      basicInfo: 'Basic Info',
      biometricVerification: 'Biometric Verification',
      nextStep: 'Next → Biometric Verification',
      previousStep: '← Previous',
      completeRegistration: '✅ Complete Registration',
      registering: 'Registering...',
      fillAllFields: 'Please fill all required fields',
      faceCaptureRequired: 'Face capture is required for registration',
      faceCaptureSuccess: 'Face captured successfully',
      faceCaptureTitle: 'Capture Face Photo',
      faceCaptureDescription: 'For security and identity verification during attendance, please capture a clear photo of your face.',
      retakePhoto: 'Retake Photo',
      capturePhoto: 'Capture Face Photo',
      faceImageRequired: 'Face capture is required to complete registration',
      
      // Navigation
      dashboard: 'Dashboard',
      employees: 'Employees',
      departments: 'Departments',
      branches: 'Company Branches',
      positions: 'Positions',
      attendance: 'Attendance',
      leaves: 'Leaves',
      mySalary: 'My Salary',
      salaries: 'Salaries',
      reports: 'Reports',
      notifications: 'Notifications',
      profile: 'Profile',
      settings: 'Settings',
      branch: 'Branch',
      
      // App Settings
      appSettings: 'App Settings',
      updateApp: 'Update App',
      updateAppDescription: 'Check for new updates and download the latest version',
      updateNow: 'Update Now',
      updatingApp: 'Updating app...',
      clearCache: 'Clear Cache',
      clearCacheDescription: 'Clear cached data to fix display issues',
      cacheCleared: 'Cache cleared successfully',
      appVersion: 'App Version',
      
      // Dashboard
      welcome: 'Welcome',
      totalEmployees: 'Total Employees',
      totalDepartments: 'Total Departments',
      activeEmployees: 'Active Employees',
      pendingApprovals: 'Pending Approvals',
      todayAttendance: 'Today Attendance',
      pendingLeaves: 'Pending Leaves',
      recentActivity: 'Recent Activity',
      
      // Employees
      addEmployee: 'Add Employee',
      employeeList: 'Employee List',
      viewEmployee: 'View Employee',
      editEmployee: 'Edit Employee',
      deleteEmployee: 'Delete Employee',
      approveEmployee: 'Approve Employee',
      rejectEmployee: 'Reject Employee',
      status: 'Status',
      role: 'Role',
      department: 'Department',
      position: 'Position',
      hireDate: 'Hire Date',
      salary: 'Salary',
      manager: 'Manager',
      actions: 'Actions',
      
      // Attendance
      checkIn: 'Check In',
      checkOut: 'Check Out',
      date: 'Date',
      checkInTime: 'Check In Time',
      checkOutTime: 'Check Out Time',
      attendanceStatus: 'Status',
      notes: 'Notes',
      present: 'Present',
      absent: 'Absent',
      late: 'Late',
      halfDay: 'Half Day',
      
      // Leaves
      requestLeave: 'Request Leave',
      leaveType: 'Leave Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      leaveStartDate: 'Leave Start Date',
      leaveEndDate: 'Leave End Date',
      reason: 'Reason',
      emergencyLeaveMonthLimit: 'Cannot take more than 2 emergency leave days per month',
      emergencyLeaveBalanceExceeded: 'Insufficient emergency leave balance',
      sickLeaveInfo: 'Sick leave is unpaid. Balance is 5 days per year. Medical report with QR required for more than 5 days.',
      medicalReport: 'Medical Report',
      medicalReportRequired: 'Medical report with QR code is required for sick leave exceeding 5 days',
      uploadMedicalReport: 'Click to upload medical report',
      medicalReportWithQR: 'Report must contain QR code for verification',
      fileUploaded: 'File uploaded',
      clickToChange: 'Click to change',
      fileTooLarge: 'File size too large (max 5MB)',
      viewMedicalReport: 'View Medical Report',
      download: 'Download',
      close: 'Close',
      unsupportedFileFormat: 'Unsupported file format',
      leaveDateConflict: 'Date conflict! You have another leave during this period',
      filterReports: 'Filter Reports',
      allBranches: 'All Branches',
      allDepartments: 'All Departments',
      allEmployees: 'All Employees',
      absentReport: 'Absence Report',
      absent: 'Absent',
      noAbsentEmployees: 'No absent employees',
      selectDailyFilter: 'Please select daily filter to view absence report',
      absentReportNote: 'Absence report is only available for daily reports. Please select "Today" filter or a single custom date.',
      showingResults: 'Showing Results',
      attendanceRecords: 'attendance records',
      leaveRequests: 'leave requests',
      employeeName: 'Employee Name',
      attendanceReport: 'Attendance Report',
      leavesReport: 'Leaves Report',
      noData: 'No data available',
      days: 'Days',
      approve: 'Approve',
      reject: 'Reject',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      annual: 'Annual Leave',
      sick: 'Sick Leave',
      emergency: 'Emergency Leave',
      unpaid: 'Unpaid Leave',
      
      // Common
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      loading: 'Loading...',
      noData: 'No data available',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      pleaseSelectDates: 'Please select start and end dates',
      endDateBeforeStartDate: 'End date must be after start date',
      startDateInPast: 'Cannot select a date in the past',
      all: 'All',
      addDepartment: 'Add Department',
      create: 'Create',
      nameEnglish: 'Name (English)',
      nameArabic: 'Name (Arabic)',
      description: 'Description',
      
      // Roles
      admin: 'Admin',
      managerRole: 'Manager',
      employee: 'Employee',
      manager: 'Manager',
      
      // Salaries
      addSalary: 'Add Salary',
      basicSalary: 'Basic Salary',
      allowances: 'Allowances',
      deductions: 'Deductions',
      total: 'Total',
      paid: 'Paid',
      markPaid: 'Mark as Paid',
      select: 'Select',
      month: 'Month',
      year: 'Year',
      
      // Status
      active: 'Active',
      inactive: 'Inactive',
      suspended: 'Suspended',
      
      // Additional
      today: 'Today',
      hours: 'Hours',
      totalHours: 'Total Hours',
      attendanceHistory: 'Attendance History',
      attendanceManagement: 'Attendance Management',
      todayStatus: 'Today Status',
      thisMonthDays: 'Days This Month',
      lateDays: 'Late Days',
      leaveDays: 'Leave Days',
      avgWorkHours: 'Avg Work Hours',
      locationReady: 'Location Ready',
      locationStatus: 'Location Status',
      refresh: 'Refresh',
      checkedInSuccess: 'Checked in successfully',
      checkedOutSuccess: 'Checked out successfully',
      totalDays: 'Total Days',
      submit: 'Submit',
      manageLocations: 'Manage Locations',
      addNewLocation: 'Add New Location',
      locationName: 'Location Name',
      latitude: 'Latitude',
      longitude: 'Longitude',
      radius: 'Allowed Radius',
      radiusHelp: 'Allowed distance from location in meters',
      useCurrentLocation: 'Use My Current Location',
      addLocation: 'Add Location',
      allowedLocations: 'Allowed Locations',
      noLocationsAdded: 'No locations added yet',
      close: 'Close',
      meters: 'meters',
      confirmReject: 'Are you sure you want to reject this employee?',
      confirmDelete: 'Are you sure you want to delete this employee?',
      remainingDays: 'days remaining',
      used: 'Used',
      days: 'days',
      print: 'Print Report',
      hrManagementSystem: 'HR Management System',
      enterEmail: 'Enter your email',
      enterPassword: 'Enter your password',
      allRightsReserved: 'All Rights Reserved',
      comprehensiveReport: 'Comprehensive Report',
      generatedOn: 'Generated on',
      totalEmployees: 'Total Employees',
      activeEmployees: 'Active Employees',
      todayAttendance: 'Today Attendance',
      pendingLeaves: 'Pending Leaves',
      employeesReport: 'Employees Report',
      recentAttendance: 'Recent Attendance',
      recentLeaves: 'Recent Leaves',
      type: 'Type',
      currency: 'Currency',
      usd: 'US Dollar (USD)',
      iqd: 'Iraqi Dinar (IQD)',
      aed: 'UAE Dirham (AED)',
      forgotPassword: 'Forgot Password?',
      sendCodeVia: 'Send code via',
      sendCode: 'Send Code',
      verificationCode: 'Verification Code',
      enterCode: 'Enter Code',
      confirmReset: 'Confirm Reset',
      backToLogin: 'Back to Login',
      confirmPassword: 'Confirm Password',
      codeNotValid: 'Code is invalid or expired',
      codeSentEmail: 'Code sent to your email',
      codeSentPhone: 'Code sent to your phone',
      sendingCode: 'Sending...',
      confirmingReset: 'Confirming...',
      sendCodeFailed: 'Failed to send code',
      weWillSendCode: 'We will send you a verification code',
      enterSentCode: 'Enter the code sent to you',
      enterNewPassword: 'Enter new password',
      
      // Notifications
      notifications: 'Notifications',
      unreadNotifications: 'unread notifications',
      markAllRead: 'Mark all as read',
      noNotifications: 'No notifications',
      allNotifications: 'All',
      unread: 'Unread',
      read: 'Read',
      new: 'new',
      justNow: 'Just now',
      minutesAgo: '{count} minutes ago',
      hoursAgo: '{count} hours ago',
      daysAgo: '{count} days ago',
      failedFetchNotifications: 'Failed to fetch notifications',
      allMarkedRead: 'All notifications marked as read',
      failedUpdateNotifications: 'Failed to update notifications',
      viewAllNotifications: 'View all notifications',
      
      // Settings
      settings: 'Settings',
      accountInfo: 'Account Info',
      changePassword: 'Change Password',
      confirmNewPassword: 'Confirm New Password',
      passwordMatched: 'Password matched',
      changingPassword: 'Changing...',
      notSpecified: 'Not specified',
      systemAdmin: 'System Admin',
      
      // Employees Modal
      editEmployee: 'Edit Employee',
      addNewEmployee: 'Add New Employee',
      fullNameEn: 'Full Name (English)',
      fullNameArLabel: 'Full Name (Arabic)',
      qualification: 'Qualification',
      qualificationPlaceholder: 'Bachelor, Master, PhD...',
      jobTitle: 'Job Title',
      jobTitlePlaceholder: 'Manager, Employee, Accountant...',
      roleLabel: 'Role',
      employeeRole: 'Employee',
      managerRoleLabel: 'Manager',
      adminRole: 'Admin',
      workBranch: 'Work Branch',
      selectBranch: '-- Select Branch --',
      selectDepartment: '-- Select Department --',
      basicSalaryLabel: 'Basic Salary',
      currencyLabel: 'Currency',
      usdCurrency: 'US Dollar (USD)',
      iqdCurrency: 'Iraqi Dinar (IQD)',
      aedCurrency: 'UAE Dirham (AED)',
      personalData: 'Personal Data (Required)',
      nationalId: 'National ID',
      nationalIdPlaceholder: 'National ID Number',
      residenceCard: 'Residence Card',
      residenceCardPlaceholder: 'Residence Card Number',
      nationality: 'Nationality',
      emiratesId: 'Emirates ID',
      unifiedCardNumber: 'Unified Card',
      addressEmirate: 'Emirate',
      addressCity: 'City',
      addressGovernorate: 'Governorate',
      addressDistrict: 'District',
      maritalStatus: 'Marital Status',
      selectOption: '-- Select --',
      single: 'Single',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      graduationYear: 'Graduation Year',
      birthDate: 'Birth Date',
      passportNumber: 'Passport Number',
      passportNumberPlaceholder: 'Passport Number',
      addressLabel: 'Address',
      addressPlaceholder: 'Full Address',
      startDate: 'Start Date',
      completeFieldsFirst: 'Complete all required fields before setting start date',
      allowances: 'Allowances',
      allowanceType: 'Allowance Type',
      amount: 'Amount',
      completeRequiredFieldsFirst: 'Please complete all required fields before setting the start date',
      installApp: 'Install App',
      appInstalled: 'App installed successfully!',
      basicInfo: 'Basic Info',
      biometricVerification: 'Biometric Verification',
      deductionsLabel: 'Deductions',
      deductionType: 'Deduction Type',
      saveEmployee: 'Save',
      cancelAction: 'Cancel',
      employeeUpdated: 'Employee updated successfully',
      employeeAdded: 'Employee added successfully',
      saveEmployeeFailed: 'Failed to save employee',
      locationSet: 'Current location detected',
      locationFailed: 'Failed to get location',
      browserNoLocation: 'Browser does not support geolocation',
      fillAllFieldsLocation: 'Please fill all fields',
      locationAdded: 'Location added successfully',
      addLocationFailed: 'Failed to add location',
      locationDeleted: 'Location deleted',
      deleteLocationFailed: 'Failed to delete location',
      locating: 'Detecting...',
      
      // MySalary
      mySalaryTitle: 'My Salary',
      accumulatedSalary: 'Accumulated Salary',
      attendanceDays: 'Attendance Days',
      paidFridays: 'Paid Weekends',
      leaveDays: 'Leave Days',
      dailyRate: 'Daily Rate',
      totalPaidDays: 'Total Paid Days',
      remainingDaysLabel: 'Remaining',
      day: 'day',
      fridayPaidNote: 'Friday is automatically paid without check-in',
      leaveNoPay: 'Leave days without pay',
      monthlySalaryDetails: 'Monthly Salary Details',
      plusAllowances: '+ Allowances',
      minusDeductions: '- Deductions',
      monthlyTotal: 'Monthly Total',
      dailyMotivation: 'Daily Motivation',
      workDayAdds: 'Each work day adds to your salary',
      daysToFullSalary: 'days to full salary',
      congratsMonthComplete: 'Congratulations! You completed the month successfully',
      totalAllowances: 'Total Allowances',
      totalDeductions: 'Total Deductions',
      earnedSoFar: 'Earned So Far',
      salaryNotSet: 'Your salary has not been set yet',
      fetchSalaryFailed: 'Failed to fetch salary info',
      
      // Branches
      companyBranches: 'Company Branches',
      addBranch: 'Add Branch',
      noBranches: 'No branches. Add a new branch.',
      editBranch: 'Edit Branch',
      addNewBranch: 'Add New Branch',
      branchNameAr: 'Branch Name (Arabic)',
      branchNameEn: 'Branch Name (English)',
      branchAddress: 'Address',
      branchAddressPlaceholder: 'Example: Baghdad - Karrada - Abu Nuwas Street',
      geoLocation: 'Geographic Location',
      detectMyLocation: 'Detect My Location',
      detectingLocation: 'Detecting...',
      mapClickHint: 'Click on the map to set branch location, or use "Detect My Location" button',
      latitudeLabel: 'Latitude',
      longitudeLabel: 'Longitude',
      allowedDistance: 'Allowed Distance (meters)',
      workHours: 'Work Hours',
      workStartTime: 'Work Start Time',
      workEndTime: 'Work End Time',
      gracePeriod: 'Grace Period (minutes)',
      branchEnabled: 'Enabled',
      branchDisabled: 'Disabled',
      branchIsActive: 'Branch is Active',
      branchUpdated: 'Branch updated successfully',
      branchAdded: 'Branch added successfully',
      saveBranchFailed: 'Failed to save branch',
      branchDeleted: 'Branch deleted',
      deleteBranchFailed: 'Failed to delete branch',
      confirmDeleteBranch: 'Are you sure you want to delete this branch?',
      pleaseSetLocation: 'Please set branch location',
      locationSuccess: 'Location detected successfully',
      locationServiceError: 'Failed to detect location. Please enable location service.',
      fetchBranchesFailed: 'Failed to fetch branches',
      minutes: 'minutes',
      
      // Attendance
      workBranchInfo: 'Work Branch',
      branchWorkHours: 'Work Hours',
      branchGracePeriod: 'Grace Period',
      completeProfileWarning: 'Please complete your personal data to activate attendance system',
      missingFields: 'Missing Fields',
      contactAdmin: 'Contact admin to complete your data',
      requiredCheckoutTime: 'Required Checkout Time',
      lateMinutes: 'Late Minutes',
      
      // Reports page
      lateReport: 'Late Employees Report',
      dateRange: 'Date Range',
      custom: 'Custom',
      selectMonth: 'Select Month',
      selectYear: 'Select Year',
      totalLateRecords: 'Total Late Records',
      uniqueLateEmployees: 'Unique Late Employees',
      totalLateMinutes: 'Total Late Minutes',
      noLateEmployees: 'No late employees',
      lateRecords: 'Late Records',
      presentToday: 'Present',
      lateToday: 'Late',
      overview: 'Overview',
      noRecords: 'No records found',
      locatingPosition: 'Detecting location...',
      locationNotAvailable: 'Your location is not available',
      allowLocationAccess: 'Please allow location access',
      locationDetected: 'Location detected successfully',
      accuracy: 'accuracy',
      checkingInProgress: 'Checking in...',
      faceNotRegistered: 'Face not registered. Please contact admin.',
      complete: 'Complete',
      inProgress: 'In Progress',
      
      // Attendance additional
      browserNoLocationSupport: 'Browser does not support location service',
      dayNotCounted: 'This day is not counted for salary',
      dayCounted: 'This day is counted',
      faceVerified: 'Face Verification',
      locationVerifiedLabel: 'Location',
      verified: 'Verified',
      notVerified: 'Not Verified',
      verificationRequired: 'Face and location verification required',
      uncountedDays: 'Uncounted Days',
      uncountedDaysNote: 'Work days without verification (face/location)',
      completeProfileFirst: 'Please complete your personal information first',
      missingFieldsCount: 'missing fields',
      faceImage: 'Biometric Face Image',
      address: 'Address',
      
      // Face Capture
      loadingFaceRecognition: 'Loading face recognition system...',
      pleaseWait: 'Please wait',
      faceModelLoadFailed: 'Failed to load face recognition model',
      cameraAccessFailed: 'Failed to access camera. Please allow access.',
      captureFaceTitle: 'Capture Face Photo',
      verifyIdentity: 'Verify Identity',
      faceDetected: 'Face detected',
      noFaceDetected: 'No face detected',
      verificationSuccess: 'Verification successful',
      faceMismatch: 'Face mismatch',
      captureInstruction: 'Place your face in the center and click "Capture"',
      verifyInstruction: 'Look at the camera to verify your identity',
      captureBtn: 'Capture Photo',
      confirmVerify: 'Confirm Verification',
      photoSuccess: 'Photo captured successfully',
      savePhoto: 'Save Photo',
      retakePhotoBtn: 'Retake',
      close: 'Close'
    }
  }
};

// Set Arabic as default language
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'ar', // Default to Arabic
    fallbackLng: 'ar', // Fallback to Arabic
    interpolation: {
      escapeValue: false
    }
  });

// Set document direction based on language
document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';

export default i18n;
